<template>
  <motion.div
      class="cta-section"
      :initial="{ opacity: 0, y: 30 }"
      :whileInView="{ opacity: 1, y: 0 }"
      :transition="{ delay: 0.4, duration: 0.6 }"
      :inViewOptions="{ once: true }"
  >
    <div class="cta-content">
      <div class="cta-text">
        <h3 class="cta-title">Brauchst du Unterstützung bei einem Laravel oder Vue Projekt? ☕</h3>
        <p class="cta-subtitle">
          Lass uns kurz quatschen. Schreib mir einfach, wo es bei euch aktuell brennt und wir schauen, ob ich euch weiterhelfen kann.<br>
          <br>
          Hinterlasse mir einfach deine Kontaktdaten – ich melde mich bei dir.
        </p>
      </div>

      <form
          name="callback-consulting"
          class="callback-form"
          method="POST"
          data-netlify="true"
          action="/"
          netlify-honeypot="bot-field"
          @submit="handleSubmit"
      >
        <input type="hidden" name="form-name" value="callback-consulting" />
        <input name="bot-field" style="display: none;" />

        <div class="form-group">
          <label for="callback-name">Name</label>
          <input
              type="text"
              id="callback-name"
              name="name"
              v-model="form.name"
              required
          />
        </div>

        <div class="form-group">
          <label for="callback-contact">Telefonnummer / E-Mail Adresse</label>
          <input
              type="text"
              id="callback-contact"
              name="contact"
              v-model="form.contact"
              required
          />
        </div>

        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input
                type="checkbox"
                name="privacy-consent"
                v-model="form.privacyConsent"
                required
            />
            Ich stimme der Verarbeitung meiner Daten gemäß der
            <router-link to="/datenschutz" class="privacy-link">Datenschutzerklärung</router-link> zu.
          </label>
        </div>

        <gradient-button type="submit" :disabled="!form.privacyConsent">
          Kostenloses Beratungsgespräch anfragen
        </gradient-button>
      </form>
    </div>
  </motion.div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { motion } from "motion-v"
import GradientButton from "@/components/GradientButton.vue"

const form = ref({
  name: '',
  contact: '',
  privacyConsent: false
})

const handleSubmit = (event: Event) => {
  if (!form.value.privacyConsent) {
    event.preventDefault()
    alert('Bitte stimme der Datenverarbeitung zu, um fortzufahren.')
  }
}
</script>

<style scoped>
.cta-section {
  max-width: 1000px;
  margin: 0 auto;
}

.cta-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
}

.cta-text {
  text-align: left;
}

.cta-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: white;
}

.cta-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

.callback-form {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 2.5rem;
  backdrop-filter: blur(6px);
}

.form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: white;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.form-group input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  font-family: inherit;
}

.form-group input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.form-group input:focus {
  outline: none;
  border-color: #00d1b2;
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 3px rgba(0, 209, 178, 0.1);
}

.checkbox-group {
  margin-bottom: 2rem;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.4;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
  vertical-align: top;
  margin: 0 8px 0 0;
}

.privacy-link {
  color: #00d1b2;
  text-decoration: none;
  transition: color 0.2s ease;
}

.privacy-link:hover {
  color: #00b8a3;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .cta-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .cta-text {
    text-align: center;
  }

  .cta-title {
    font-size: 1.5rem;
  }

  .cta-subtitle {
    font-size: 1rem;
  }

  .callback-form {
    padding: 2rem;
  }
}
</style>
